import { NewQueryResponse } from '~types/common.type';

enum ReasonType {
  UNPINNING = 'UNPINNING',
}

enum UnpinningReasonKey {
  UNPINNING_REASONS_FOR_STATION_SWAPS = 'UNPINNING_REASONS_FOR_STATION_SWAPS',
  UNPINNING_REASONS_FOR_STATION_RELOCATION = 'UNPINNING_REASONS_FOR_STATION_RELOCATION',
}

type ReasonFilter = {
  reasonTypes?: ReasonType[];
  searchByReason?: string;
  filterByKeys?: UnpinningReasonKey[];
};

type ReasonListingRequestParams = {
  page: number;
  size: number;
  filter?: ReasonFilter;
};

type Reason = {
  id: string;
  reason: string;
};

type ReasonListingResponse = NewQueryResponse<Reason>;

export type {
  Reason,
  ReasonFilter,
  ReasonListingRequestParams,
  ReasonListingResponse,
};

export { ReasonType, UnpinningReasonKey };
